import React from 'react';
import { gettingStartedSteps } from '../../data/landingContent';
export function GettingStarted() {
  return <section id="getting-started" className="scroll-mt-6 border-y border-[#A6B6F8]/50 bg-[#A6B6F8]/20" data-id="element-66" data-mp="f7wayf8m75d4">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[0.72fr_1.28fr] lg:gap-20" data-id="element-67" data-mp="k8jyus1jr634">
        <div data-id="element-68" data-mp="p50xig6dh2ug">
          <p className="text-xs font-bold uppercase tracking-[0.16em] text-[#5B5299]" data-id="element-69" data-mp="3nor596bcjhfl">
            A quick guide
          </p>
          <h2 className="mt-3 text-3xl font-bold tracking-[-0.035em] sm:text-4xl" data-id="element-70" data-mp="3sn10fgx2mi17">
            Getting started.
          </h2>
          <p className="mt-4 text-base leading-7 text-[#3A3A3A]" data-id="element-71" data-mp="1gr9r8plm50o">
            Get your business up and running with Credit Manager in three simple
            steps.
          </p>
          <a href="/signup" className="mt-6 inline-flex items-center gap-2 rounded-lg bg-[#041F60] px-5 py-3.5 text-sm font-bold text-white transition hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#041F60] focus:ring-offset-2 focus:ring-offset-[#A6B6F8]/20" data-id="element-72" data-mp="34x6od1kksxi0">
            Start your free trial
          </a>
        </div>

        <ol className="border-t border-[#A6B6F8]/60" data-id="element-73" data-mp="15kwhl23gnl3e">
          {gettingStartedSteps.map(step => <li key={step.number} className="grid gap-5 border-b border-[#A6B6F8]/60 py-7 sm:grid-cols-[80px_1fr] sm:items-start sm:gap-7" data-id="element-74" data-mp="10mcv90kyg7ai">
              <span className="grid h-14 w-14 place-items-center rounded-full bg-[#041F60] font-mono text-lg font-medium tracking-tight text-[#4BE4FF] sm:h-16 sm:w-16 sm:text-xl" data-id="element-75" data-mp="rlele1nu55k0">
                {step.number}
              </span>
              <div className="pt-0.5 sm:pt-2" data-id="element-76" data-mp="ho0jr86kmlbr">
                <h3 className="text-xl font-bold tracking-tight" data-id="element-77" data-mp="hpbmr5s6zp1t">
                  {step.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-[#3A3A3A]" data-id="element-78" data-mp="2c18gx6i0r90k">
                  {step.description}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}